import React, { useState, useEffect } from "react";
import Context from "../../../../Context";
import { useToast } from "../../../../components/ui";
import { FaCheckCircle } from "react-icons/fa";
import { OrderPrizeBadge } from "./OrderPrizeBadge";
import { OrderLotteryGallery } from "./OrderLotteryGallery";
import { OrderGeneralForm } from "./OrderGeneralForm";
import { OrderPayoutBank } from "./OrderPayoutBank";
import { OrderBuyFor } from "./OrderBuyFor";
import { OrderShipping } from "./OrderShipping";
import { OrderCoupon } from "./OrderCoupon";
import { OrderNotifications } from "./OrderNotifications";

export const OrderBody = ({ order, user }) => {
  const { toast } = useToast();
  const { callApi, configs } = Context();
  const [loading, setLoading] = useState(false);
  const [orderInfo, setOrderInfo] = useState(order || {});

  useEffect(() => {
    if (order) {
      setOrderInfo(order);
    }
  }, [order]);

  const updateValue = async (key, value) => {
    if (!window.confirm("ต้องการแก้ไขข้อมูลใช่หรือไม่?")) {
      setOrderInfo(order);
      return false;
    }

    setLoading(true);
    try {
      const result = await callApi(
        "orders-edit",
        {
          id: order.id,
          key: key,
          value: value,
        },
        {
          notShowLoading: true,
        }
      );

      if (result?.status) {
        toast({
          className: "bg-emerald-600 text-white font-semibold",
          title: (
            <div className="flex gap-2 items-center">
              <FaCheckCircle /> อัปเดตข้อมูลสำเร็จ
            </div>
          ),
        });
        return true;
      } else {
        toast({
          className: "bg-rose-600 text-white font-semibold",
          title: (
            <div className="flex gap-2 items-center">
              <FaCheckCircle /> อัปเดตข้อมูลไม่สำเร็จ
            </div>
          ),
          description: result?.message || "เกิดข้อผิดพลาดในการบันทึก",
        });
        setOrderInfo(order);
        return false;
      }
    } catch (err) {
      console.error("updateValue error:", err);
      setOrderInfo(order);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative col-span-3 border-r border-slate-200 pr-4 pb-4">
      {loading && (
        <div className="absolute inset-0 z-50 bg-white/70 backdrop-blur-2xs flex items-center justify-center rounded-md">
          <div className="w-8 h-8 border-3 border-blue-600 border-t-transparent rounded-full animate-spin" />
        </div>
      )}

      {/* แบนเนอร์แสดงสถานะถูกรางวัล (ถ้ามี) */}
      <OrderPrizeBadge order={orderInfo} />

      {/* สลากในคำสั่งซื้อ */}
      <OrderLotteryGallery lotteries={order?.lotteries} />

      {/* ข้อมูลคูปองและสิทธิพิเศษ / โปรโมชั่น (ถ้ามี) */}
      <OrderCoupon orderInfo={orderInfo} />

      {/* ข้อมูลทั่วไปของคำสั่งซื้อ */}
      <OrderGeneralForm
        orderInfo={orderInfo}
        setOrderInfo={setOrderInfo}
        updateValue={updateValue}
        loading={loading}
        configs={configs}
        toast={toast}
      />

      {/* บัญชีรับเงินรางวัล */}
      <OrderPayoutBank
        orderInfo={orderInfo}
        setOrderInfo={setOrderInfo}
        user={user}
        updateValue={updateValue}
        loading={loading}
      />

      {/* ซื้อให้บุคคลอื่น */}
      <OrderBuyFor
        orderInfo={orderInfo}
        setOrderInfo={setOrderInfo}
        updateValue={updateValue}
        loading={loading}
      />

      {/* ข้อมูลการจัดส่งไปรษณีย์ */}
      <OrderShipping
        orderInfo={orderInfo}
        setOrderInfo={setOrderInfo}
        updateValue={updateValue}
        loading={loading}
      />

      {/* การแจ้งเตือน SMS / LINE */}
      <OrderNotifications
        orderInfo={orderInfo}
        callApi={callApi}
        setLoading={setLoading}
      />
    </div>
  );
};
